import { DATABASE_NAME } from '@env'
import { collection, doc, getDocs, onSnapshot, query, where } from 'firebase/firestore'
import { auth, db } from '../config'
import '../../global'
import { Collection } from '../firebase.enums'
import { GiftCard } from '../../screens/Checkout/Helpers/validateGiftCard'

export const getGiftCards = async () => {
	return new Promise((resolve, reject) => {
		const dataImport = { giftCards: [] }
		const giftCardsRef = collection(db, Collection.GiftCards)

		onSnapshot(
			giftCardsRef,
			snapshot => {
				snapshot.docChanges().forEach(change => {
					const data = change.doc.data()
					if (!data.isDeleted) {
						dataImport.giftCards.push({
							id: change.doc.id,
							...data,
						})
					}
				})

				resolve(dataImport)
			},
			reject
		)
	})
}

export const getGiftCardByCode = async (code: string): Promise<GiftCard | null> => {
	try {
		const giftCardsRef = collection(doc(db, DATABASE_NAME, global.org), Collection.GiftCards)
		const fbQuery = query(giftCardsRef, where('code', '==', code))

		const giftCardsSnapshot = await getDocs(fbQuery)
		const document = giftCardsSnapshot.docs[0]

		if (!document) {
			console.log(`Gift Card with code ${code} does not exist.`)
			return null
		}

		return document.data() as any
	} catch (error) {
		console.error('Error getting document:', error)
		return null
	}
}
